import { useEffect, useState } from "react";
import { getMyApplications } from "../../../../services/applicationService"; // ajuste o caminho
import JobCard from "../JobCard/JobCard";
import EmptyState from "../../../../Components/EmptyState/EmptyState";
import FreelancerViewCompanyModal from "../../../../Components/FreelancerViewCompanyModal/FreelancerViewCompanyModal";
import Toast from "../../../../Components/Toast/Toast"
import "./MyApplications.scss";

const STATUS_LABELS = {
    pending: { label: "Pendentes", key: "pending" },
    approved: { label: "Aprovadas", key: "approved" },
    rejected: { label: "Recusadas", key: "rejected" },
};

export default function MyApplications({ onViewFinished }) {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filter, setFilter] = useState("all");
    const [viewingCompanyId, setViewingCompanyId] = useState(null);
    const [toast, setToast] = useState({ message: "", type: "success" });

    const showToast = (message, type = "success") => {
        setToast({ message, type });
    };

    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await getMyApplications();
                setApplications(data);
            } catch (err) {
                const msg = getErrorMessage(
                    err,
                    "Erro ao carregar suas candidaturas."
                );

                showToast(msg, "error");
            } finally {
                setLoading(false);
            }
        };

        fetch();
    }, []);

    const filters = [
        { key: "all", label: "Todas" },
        { key: "pending", label: "⏳ Pendentes" },
        { key: "approved", label: "✅ Aprovadas" },
        { key: "rejected", label: "❌ Recusadas" },
    ];

    const filtered = filter === "all"
        ? applications
        : applications.filter((a) => a.status === filter);

    if (loading) {
        return (
            <div className="my-applications__centered">
                <p className="my-applications__loading">Carregando candidaturas...</p>
            </div>
        );
    }

    if (applications.length === 0) {
        return <EmptyState message="Você ainda não se candidatou a nenhuma vaga." />;
    }

    return (
        <div className="my-applications">
            <div className="my-applications__filters">
                {filters.map((f) => (
                    <button
                        key={f.key}
                        className={`my-applications__chip ${filter === f.key ? "my-applications__chip--active" : ""}`}
                        onClick={() => setFilter(f.key)}
                    >
                        {f.label}
                    </button>
                ))}
            </div>

            {filtered.length === 0 ? (
                <EmptyState message={`Nenhuma candidatura ${STATUS_LABELS[filter]?.label.toLowerCase() ?? ""}.`} />
            ) : (
                <div className="my-applications__grid">
                    {filtered.map((application) => (
                        <JobCard
                            key={application.id}
                            job={application.job}
                            applicationStatus={application.status}
                            onViewFinished={onViewFinished}
                            onViewCompany={() => setViewingCompanyId(application.job.companyId)}
                        />
                    ))}
                </div>
            )}

            {viewingCompanyId && (
                <FreelancerViewCompanyModal
                    companyId={viewingCompanyId}
                    onClose={() => setViewingCompanyId(null)}
                />
            )}

            <Toast
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ message: "", type: "success" })}
            />
        </div>
    );
}